import React from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import { Navbar } from "./Navbar.tsx";
import { Footer } from "./Footer.tsx";
import { StyledBox, StyledMainContent, StyledSkipLink } from "./styled/CommonStyles.tsx";

interface LayoutProps {
  onOpenBookingDialog: () => void;
}

export const Layout: React.FC<LayoutProps> = ({ onOpenBookingDialog }) => {
  return (
    <StyledBox>
      {/* Skip to main content link for keyboard users */}
      <StyledSkipLink href="#main-content">
        Ga naar hoofdinhoud
      </StyledSkipLink>

      {/* Navbar */}
      <Navbar onOpenBookingDialog={onOpenBookingDialog} />

      {/* Main Content */}
      <StyledMainContent component="main" id="main-content">
        <Outlet />
      </StyledMainContent>

      {/* Footer */}
      <Footer />
    </StyledBox>
  );
}; 